import React from "react";
import { Redirect, Switch } from "react-router-dom";
import PathUtil from "../../../../utils/PathUtil";
import MessageAlert from "../../../core/MessageAlert";
import PrivateRoute from "../../../core/PrivateRoute";
import withLoader from "../../../core/withLoader";
import { paths } from "../../../paths";
import InvolvementRoleTypes from "../../Administration/InvolvementRoleTypes";
import InvolvementRoleType from "../../Administration/InvolvementRoleTypes/Detail";
import ClassificationAdministration from "../../Administration/KM/Classification";
import ClassificationDetail from "../../Administration/KM/Classification/entity/detail";
import EntityRelationshipType from "../../Administration/KM/EntityRelationshipType";
import Extensions from "../../Administration/KM/Extension";
import KnowledgeAdministration from "../../Administration/KM/Knowledge";
import LifeCycleAdministration from "../../Administration/LifeCycleAdministration";
import LifeCycleClassDefinitionDetails from "../../Administration/LifeCycleAdministration/LifeCycleClassDefinitionDetails";
import LifeCycle from "../../Administration/LifeCycleAdministration/LifeCycleClassDefinitionDetails/LifeCycle";
import MessageLogType from "../../Administration/MessageLogTypeAdministration/MessageLogType";
import RoleTypes from "../../Administration/Roles/RoleTypes";
import RoleTypeDetail from "../../Administration/Roles/RoleTypes/Detail";
import System from "../../Administration/System";
import IndividualsAdministration from "../../Administration/Individuals";
import IndividualDetail from "../../Administration/Individuals/IndividualDetail";
import PartyRoleDetail from "../../Administration/PartyRoles/PartyRoleDetail";
import InvolvementRole from "../../Administration/PartyRoles/PartyRoleDetail/InvolvementRoles/Detail";
import AdvancedSearch from "../../AdvancedSearch";
import KnowledgeManagement from "../../KnowledgeManagement";
import KnowledgeItem from "../../KnowledgeManagement/KnowledgeItem";
import PartyMessages from "../../PartyMessages";
import PartyMessagesDetail from "../../PartyMessages/Detail";
import ClassificationPartySubscriptions from "../../PartySubscriptions/ClassificationPartySubscriptions";
import Home from "../Home";
import TopBar from "../TopBar";
import Readme from "../Readme";
import OrganisationsAdministration from "../../Administration/Organisations";
import OrganisationDetail from "../../Administration/Organisations/OrganisationDetail";

const PageBody = props => {
  const handlerProps = {
    breadcrumbsHandler: props.breadcrumbsHandler,
    messageHandler: props.messageHandler
  };

  return (
    <>
      <TopBar
        breadcrumbsRef={props.breadcrumbsRef}
        onBreadcrumbClick={props.onBreadcrumbClick}
        onHomeMenuClick={props.onHomeMenuClick}
        notificationBadgeRefreshPropagator={
          props.notificationBadgeRefreshPropagator
        }
        {...handlerProps}
      />
      <MessageAlert
        ref={props.alertRef}
        desktopClassName="messageAlertDesktop"
        mobileClassName="messageAlertMobile"
      />

      <div className="PageBody">
        <Switch>
          <PrivateRoute
            path={paths.README_PATH}
            component={Readme}
            {...handlerProps}
          />

          <PrivateRoute
            path={paths.HOME_PATH}
            component={Home}
            {...handlerProps}
          />

          <PrivateRoute
            path={paths.KNOWLEDGE_MANAGMENT}
            component={KnowledgeManagement}
            {...handlerProps}
            includeAddButton
            includeAdvancedSearchButton
            includeActiveDropdown
          />
          <PrivateRoute
            path={paths.KNOWLEDGE_ITEM}
            routeRender={({ match: { path } }) => (
              <>
                <PrivateRoute
                  path={PathUtil.itemPathDescriptor(path)}
                  component={KnowledgeItem}
                  {...handlerProps}
                />
              </>
            )}
          />
          <PrivateRoute
            path={paths.ADVANCED_SEARCH}
            component={AdvancedSearch}
            {...handlerProps}
          />

          <PrivateRoute
            path={paths.PARTY_MESSAGES}
            routeRender={({ match: { path } }) => (
              <>
                <PrivateRoute
                  exact
                  path={path}
                  {...handlerProps}
                  componentRef={props.partyMessagesRef}
                  component={PartyMessages}
                />
                <PrivateRoute
                  path={PathUtil.itemPathDescriptor(`${path}${paths.DETAIL}`)}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={PartyMessagesDetail}
                        {...handlerProps}
                      />
                    </>
                  )}
                />
              </>
            )}
          />

          <PrivateRoute
            path={paths.ADMINISTRATION}
            routeRender={({ match: { path } }) => (
              <>
                <PrivateRoute
                  path={`${path}${paths.CLASSIFICATIONS}`}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={ClassificationAdministration}
                        {...handlerProps}
                      />
                      <PrivateRoute
                        path={PathUtil.itemPathDescriptor(
                          `${path}${paths.DETAIL}`
                        )}
                        routeRender={({ match: { path } }) => (
                          <>
                            <PrivateRoute
                              exact
                              path={path}
                              component={ClassificationDetail}
                              {...handlerProps}
                            />
                          </>
                        )}
                      />
                    </>
                  )}
                />
                <PrivateRoute
                  path={`${path}${paths.KNOWLEDGE}`}
                  component={KnowledgeAdministration}
                  {...handlerProps}
                />
                <PrivateRoute
                  path={`${path}${paths.SYSTEM}`}
                  component={System}
                  {...handlerProps}
                />

                <PrivateRoute
                  path={`${path}${paths.EXTENSION}`}
                  component={Extensions}
                  {...handlerProps}
                />
                <PrivateRoute
                  path={`${path}${paths.MESSAGE_LOG_TYPE}`}
                  component={MessageLogType}
                  {...handlerProps}
                />
                <PrivateRoute
                  path={`${path}${paths.ENTITY_RELATIONSHIP_TYPES}`}
                  component={EntityRelationshipType}
                  {...handlerProps}
                />

                <PrivateRoute
                  path={`${path}${paths.LIFE_CYCLE}`}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={LifeCycleAdministration}
                        {...handlerProps}
                      />
                      <PrivateRoute
                        path={PathUtil.itemPathDescriptor(
                          `${path}${paths.DETAIL}`
                        )}
                        routeRender={({ match: { path } }) => (
                          <>
                            <PrivateRoute
                              exact
                              path={path}
                              component={LifeCycle}
                              {...handlerProps}
                            />
                          </>
                        )}
                      />
                      <PrivateRoute
                        path={PathUtil.itemPathDescriptor(
                          `${path}${paths.CLASS_DEFINITION}`
                        )}
                        routeRender={({ match: { path } }) => (
                          <>
                            <PrivateRoute
                              exact
                              path={path}
                              component={LifeCycleClassDefinitionDetails}
                              {...handlerProps}
                              dontLoadAfterMount
                            />
                          </>
                        )}
                      />
                    </>
                  )}
                />
                <PrivateRoute
                  path={`${path}${paths.ROLES}`}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={RoleTypes}
                        {...handlerProps}
                      />
                      <PrivateRoute
                        path={PathUtil.itemPathDescriptor(
                          `${path}${paths.DETAIL}`
                        )}
                        routeRender={({ match: { path } }) => (
                          <>
                            <PrivateRoute
                              exact
                              path={path}
                              component={RoleTypeDetail}
                              {...handlerProps}
                            />
                          </>
                        )}
                      />
                    </>
                  )}
                />
                <PrivateRoute
                  path={`${path}${paths.INDIVIDUALS}`}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={IndividualsAdministration}
                        {...handlerProps}
                      />
                      <PrivateRoute
                        path={PathUtil.itemPathDescriptor(path, false)}
                        routeRender={({ match: { path } }) => (
                          <>
                            <PrivateRoute
                              exact
                              path={path}
                              component={IndividualDetail}
                              dontLoadAfterMount
                              {...handlerProps}
                            />
                            <PrivateRoute
                              path={PathUtil.itemPathDescriptor(
                                `${path}${paths.PARTYROLES}`,
                                true,
                                { old: "id", new: "partyId" }
                              )}
                              routeRender={({ match: { path } }) => (
                                <>
                                  <PrivateRoute
                                    exact
                                    path={path}
                                    component={PartyRoleDetail}
                                    {...handlerProps}
                                  />
                                  <PrivateRoute
                                    path={PathUtil.itemPathDescriptor(
                                      `${path}${paths.INVOLVEMENTROLES}`,
                                      true,
                                      { old: "id", new: "partyRoleId" }
                                    )}
                                    routeRender={({ match: { path } }) => (
                                      <PrivateRoute
                                        exact
                                        path={path}
                                        component={InvolvementRole}
                                        {...handlerProps}
                                      />
                                    )}
                                  />
                                </>
                              )}
                            />
                          </>
                        )}
                      />
                    </>
                  )}
                />
                  <PrivateRoute
                      path={`${path}${paths.ORGANISATIONS}`}
                      routeRender={({ match: { path } }) => (
                          <>
                              <PrivateRoute
                                  exact
                                  path={path}
                                  component={OrganisationsAdministration}
                                  {...handlerProps}
                              />
                              <PrivateRoute
                                  path={PathUtil.itemPathDescriptor(path, false)}
                                  routeRender={({ match: { path } }) => (
                                      <>
                                          <PrivateRoute
                                              exact
                                              path={path}
                                              component={OrganisationDetail}
                                              dontLoadAfterMount
                                              {...handlerProps}
                                          />
                                          <PrivateRoute
                                              path={PathUtil.itemPathDescriptor(
                                                  `${path}${paths.PARTYROLES}`,
                                                  true,
                                                  { old: "id", new: "organisationId" }
                                              )}
                                              routeRender={({ match: { path } }) => (
                                                  <>
                                                      <PrivateRoute
                                                          exact
                                                          path={path}
                                                          component={PartyRoleDetail}
                                                          {...handlerProps}
                                                      />
                                                      <PrivateRoute
                                                          path={PathUtil.itemPathDescriptor(
                                                              `${path}${paths.INVOLVEMENTROLES}`,
                                                              true,
                                                              { old: "id", new: "organisationRoleId" }
                                                          )}
                                                          routeRender={({ match: { path } }) => (
                                                              <PrivateRoute
                                                                  exact
                                                                  path={path}
                                                                  component={InvolvementRole}
                                                                  {...handlerProps}
                                                              />
                                                          )}
                                                      />
                                                  </>
                                              )}
                                          />
                                      </>
                                  )}
                              />
                          </>
                      )}
                  />
                <PrivateRoute
                  path={`${path}${paths.INVOLVEMENTROLETYPES}`}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={InvolvementRoleTypes}
                        {...handlerProps}
                      />
                      <PrivateRoute
                        path={PathUtil.itemPathDescriptor(
                          `${path}${paths.DETAIL}`
                        )}
                        routeRender={({ match: { path } }) => (
                          <>
                            <PrivateRoute
                              exact
                              path={path}
                              component={InvolvementRoleType}
                              {...handlerProps}
                            />
                          </>
                        )}
                      />
                    </>
                  )}
                />
              </>
            )}
          />

          <PrivateRoute
            path={paths.SUBSCRIPTIONS}
            routeRender={({ match: { path } }) => (
              <>
                <PrivateRoute
                  path={`${path}${paths.CLASSIFICATIONS}`}
                  routeRender={({ match: { path } }) => (
                    <>
                      <PrivateRoute
                        exact
                        path={path}
                        component={ClassificationPartySubscriptions}
                        {...handlerProps}
                      />
                    </>
                  )}
                />
              </>
            )}
          />
          <Redirect from={paths.APPLICATION_PATH} to={paths.HOME_PATH} exact />
        </Switch>
      </div>
    </>
  );
};

export default withLoader(PageBody);
